/** @jsx jsx */
import React, { useRef } from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { MatchUpDetailSportTalkWrap } from '@views/Matchup/MatchUpDetail/index.style'
import { isMobile } from 'react-device-detect'
import classNames from 'classnames'
import { SimpleMatchTrack } from '@store/matchupStore'
import useRootStore from '@store/useRootStore'
import { SportTalk } from '@views/Matchup/MatchUpDetail/TabContent/SportTalk'
import { useOnMount, useOnUnmount } from '@utils/reactExt'
import { runInAction } from 'mobx'

interface MatchUpDetailSportTalkProps {
  track: SimpleMatchTrack
  isGameInfoMatchChart?: boolean
}

export const MatchupDetailSportTalk: React.FC<MatchUpDetailSportTalkProps> = observer((props) => {
  const {
    track,
    isGameInfoMatchChart = false,
  } = props
  const { cheerForTeamStore, matchupStore, globalStore } = useRootStore()
  const { sportTalkDetailList, hasMoreCheerForTeam } = cheerForTeamStore
  const cheerForTeamStoreRef = useRef(cheerForTeamStore)
  const matchupStoreRef = useRef(matchupStore)
  const contentWrapRef = useRef(null)

  const { sportId } = track || ({} as SimpleMatchTrack)

  const fetchSportTalk = async (matchId: number, reset = false) => {
    const timelineEnabled = globalStore.getSportTalkMatchTimelineEnabled()
    matchupStoreRef.current.fetchMatchupDetailPackage({ matchId, sportId }).catch(console.error)
    await cheerForTeamStoreRef.current.fetchSportTalkListInMatchDetail(matchId, reset, !timelineEnabled)
  }

  const matchUpDetailSportTalkClassName = classNames(
    '',
    { 'pc': !isMobile },
    { 'is-game-info-match-chart': isGameInfoMatchChart },
  )

  useOnMount(() => {
    const wrapper = document.getElementById('matchDetailWrap')
    contentWrapRef.current = wrapper
  })

  useOnUnmount(() => {
    if (contentWrapRef.current) {
      contentWrapRef.current = null
    }

    runInAction(() => {
      cheerForTeamStore.sportTalkDetailList = []
    })
  })

  return (
    <MatchUpDetailSportTalkWrap className={matchUpDetailSportTalkClassName}>
      <SportTalk
        track={track}
        contentWrapRef={contentWrapRef}
        sportTalkItems={sportTalkDetailList}
        hasMoreSportTalk={hasMoreCheerForTeam}
        fetchSportTalkHandler={fetchSportTalk}
      />
    </MatchUpDetailSportTalkWrap>
  )
})
